// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cc68fc58","498":"5ee16b79","703":"0679ce03"}[chunkId] + ".chunk.js";
};